import { Box } from "@mui/material";
import { useTranslation } from "../../localization/useTranslation.ts";

export interface AIDialogDisclaimerProps {
    translationKey?: "aiQualityScanDisclaimer" | "aiChatDisclaimer";
}

function AIDialogDisclaimer({ translationKey = "aiQualityScanDisclaimer" }: AIDialogDisclaimerProps) {
    const { translateString } = useTranslation();
    return <Box sx={(theme) => ({ fontSize: theme.typography.pxToRem(12), color: theme.palette.grey[600] })}>{translateString(translationKey)}</Box>;
}

export default AIDialogDisclaimer;
